var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_33043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.9 974.601H1766.9V968.801L1761.8 962.801H1707.9V974.601Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.7 974.601H1707.9V962.801H1690.7L1684.7 968.701V974.601Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.19 911.602H1745.09V962.802H1754.19V911.602Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.2 911.602H1724.7V962.802H1745.2V911.602Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.7 945.102H1708.2V949.202H1734.7V945.102Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.2 945.102H1697.8V949.202H1708.2V945.102Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1776.7 899.102H1687.5V908.402H1776.7V899.102Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.8 814.902H1798.8L1765.6 908.302H1776.7L1809.8 814.902Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.6 908.301H1721.3V911.601H1765.6V908.301Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.2 899.103H1771.9L1776.7 887.703H1691.2V899.103Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.9 887.702H1776.7L1802.2 814.902H1749.5L1723.9 887.702Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.9 887.702H1766.8L1792.4 814.902H1749.5L1723.9 887.702Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.1 887.703H1691.2V899.003H1738.1V887.703Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.6 821.803C1773.6 822.103 1761.4 822.103 1750.4 821.803C1761.4 821.503 1773.5 821.503 1784.6 821.803Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.5 831.202C1770.5 831.502 1758.3 831.502 1747.3 831.202C1758.3 830.902 1770.4 830.902 1781.5 831.202Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.4 840.702C1767.4 841.002 1755.2 841.002 1744.2 840.702C1755.2 840.402 1767.3 840.402 1778.4 840.702Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.29 850.104C1764.29 850.404 1752.09 850.404 1741.09 850.104C1752.09 849.804 1764.19 849.804 1775.29 850.104Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.2 859.604C1761.2 859.904 1749 859.904 1738 859.604C1749 859.304 1761.1 859.304 1772.2 859.604Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.1 869.002C1758.1 869.302 1745.9 869.302 1734.9 869.002C1745.9 868.702 1758 868.702 1769.1 869.002Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766 878.502C1755 878.802 1742.8 878.802 1731.8 878.502C1742.8 878.202 1754.9 878.202 1766 878.502Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.8 929.102H1633.9V940.402H1680.8V929.102Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.7 940.403L1738.1 899.103V887.703L1680.7 929.103V940.403Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.9 929.103L1691.2 887.703H1738.1L1680.7 929.103H1633.9Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.8 828.799C1754.7 839.299 1749.1 851.399 1745.8 853.599C1739.2 857.899 1731.8 861.299 1727.7 861.999C1725.6 862.399 1719.1 849.599 1721.1 848.299C1723.9 846.399 1735.6 840.599 1736.3 840.099C1736.2 841.399 1768.1 804.499 1759.8 828.799Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.89 862.599C1717.89 862.699 1717.79 863.299 1716.29 864.199C1696.19 872.999 1720.29 872.799 1728.09 861.699C1725.89 861.999 1720.89 862.199 1716.89 862.599Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.9 847.199C1718.1 848.299 1708.7 848.699 1705.3 854.699C1703 856.499 1703.2 858.199 1703.2 858.199C1701.6 860.599 1702 862.199 1702 862.199C1702 862.199 1699.3 864.399 1700.4 866.199C1701.6 868.299 1705.1 864.799 1708.2 863.999C1715.3 862.299 1725.9 861.899 1728 861.699L1723.9 847.199Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714.4 857.098C1710 857.798 1705.6 860.198 1702 862.198C1705.2 859.498 1710.5 857.198 1714.4 857.098Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1714 852.598C1712 853.198 1708.3 854.498 1703.2 858.198C1706.1 855.398 1710.4 853.098 1714 852.598Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.7 850.199C1710.3 851.399 1708.3 852.699 1705.2 854.599C1708.4 852.099 1710.7 850.799 1713.7 850.199Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737 850.399C1736.9 849.699 1736.7 848.999 1736.3 848.499C1736.9 847.099 1736 845.499 1737.1 844.299C1737.9 844.599 1738.8 843.799 1738.9 842.799C1739.1 842.399 1739.7 841.899 1739.3 841.399C1738.7 840.799 1738.1 841.799 1737.4 841.799C1736.6 841.799 1736 842.499 1736.2 843.199C1734.6 843.999 1735.1 845.799 1734.8 847.299C1734.2 847.099 1733.5 846.999 1732.9 846.999C1733.4 843.999 1729 842.599 1727.8 845.099C1726.2 847.599 1729.2 849.899 1731.5 848.899C1732.7 850.799 1734.4 850.499 1735 850.099C1735.6 851.799 1733.4 853.099 1732 852.299C1730.2 850.699 1728.1 847.299 1725.6 849.799C1721.8 852.899 1729.3 855.999 1724.9 857.299C1724.8 857.299 1724.8 857.499 1725.1 857.499C1728.4 857.499 1727.5 854.999 1726.4 853.099C1726.6 848.499 1729.7 852.999 1731.1 853.999C1733.9 855.899 1737.2 853.499 1737 850.399ZM1729.5 846.299C1730.1 845.299 1731 846.599 1731 847.399C1729.8 847.499 1729.2 846.899 1729.5 846.299Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.8 847.398C1735.4 847.498 1736 847.998 1736.3 848.498C1735.9 848.098 1735.4 847.598 1734.8 847.398Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735 850.299C1734.7 849.699 1734.2 849.199 1733.5 848.999C1733.1 848.499 1732.8 847.799 1732.8 847.199C1732.8 847.899 1733.1 848.499 1733.5 848.999C1734.3 849.099 1734.8 849.599 1735 850.299Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.5 848.998C1731.2 848.498 1731 847.898 1731 847.398C1731.1 847.998 1731.3 848.498 1731.5 848.998Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.1 848.098C1733 847.998 1733.1 847.998 1733.1 848.098V848.098Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1734 852.5C1735.7 851.8 1735.3 849.4 1733.6 848.9C1733.4 848.6 1733.2 848.3 1733.1 848C1735.7 847.8 1736.5 851.7 1734 852.5Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1733.7 848.9C1733.5 848.6 1733.5 848.3 1733.6 848C1733.6 848.4 1733.6 848.7 1733.7 848.9Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1734.5 849.498C1734.6 849.298 1734.8 849.098 1735 848.898C1734.9 849.098 1734.7 849.298 1734.5 849.498Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1735.5 849.701C1735.3 849.801 1735.1 849.801 1734.9 850.001C1735 849.801 1735.2 849.701 1735.5 849.701Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1735.6 850.301C1735.4 850.301 1735.3 850.301 1735.1 850.401C1735.2 850.301 1735.4 850.301 1735.6 850.301Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1735.3 851.299C1735.2 851.299 1735.1 851.199 1735 851.199C1735.2 851.199 1735.3 851.299 1735.3 851.299Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1735.1 851.702C1735 851.702 1735 851.602 1734.9 851.602C1735 851.702 1735 851.702 1735.1 851.702Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1734.8 852.1C1734.7 852 1734.7 852.1 1734.8 852.1C1734.7 852 1734.7 852 1734.7 852C1734.7 852 1734.8 852 1734.8 852.1Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1731.5 848.998C1731.2 849.098 1730.8 849.098 1730.5 849.098C1728.3 849.498 1726.4 846.998 1727.8 845.098C1727 847.098 1729.4 848.398 1731.2 847.998C1731.2 848.498 1731.3 848.798 1731.5 848.998Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1727.4 845.999C1727.4 845.899 1727.5 845.799 1727.6 845.699C1727.6 845.699 1727.6 845.699 1727.6 845.799C1727.5 845.899 1727.5 845.999 1727.4 845.999Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1727.3 846.498C1727.3 846.298 1727.5 846.198 1727.6 846.098C1727.6 846.098 1727.6 846.098 1727.6 846.198C1727.5 846.198 1727.4 846.298 1727.3 846.498Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1727.59 847.796C1727.59 847.496 1727.79 847.196 1727.99 846.996C1727.79 847.296 1727.69 847.496 1727.59 847.796Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1728.09 848.398C1727.99 847.998 1728.09 847.698 1728.29 847.398C1728.19 847.798 1728.09 848.098 1728.09 848.398Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1729.7 849.198C1729.4 848.798 1729.4 848.498 1729.5 848.098C1729.5 848.498 1729.5 848.898 1729.7 849.198Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1730.49 849.199C1730.19 848.899 1730.09 848.499 1730.19 848.199C1730.19 848.499 1730.29 848.899 1730.49 849.199Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1730.9 854.1C1729.5 853.2 1727.1 849 1726.2 852.6C1726 854 1727.7 854.9 1727.3 856.3C1727.5 855.1 1726.4 854.301 1725.9 853.401C1725.1 852.201 1725.8 850.2 1727.4 850.3C1729.3 850.7 1729.5 853.2 1730.9 854.1Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1730.1 853.301L1730 853.401C1730 853.301 1730.1 853.301 1730.1 853.301Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1729.6 853.001C1729.7 852.901 1729.7 852.901 1729.8 852.801C1729.8 852.901 1729.7 853.001 1729.6 853.001Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1727.6 851.202C1727.6 850.902 1727.6 850.602 1727.4 850.402C1727.6 850.702 1727.7 851.002 1727.6 851.202Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.9 851.402C1726.7 851.202 1726.4 851.002 1726.1 850.902C1726.5 851.002 1726.7 851.202 1726.9 851.402Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.4 852.002C1726.1 851.902 1725.9 851.802 1725.6 851.902C1725.9 851.802 1726.2 851.802 1726.4 852.002Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.2 852.702C1726 852.702 1725.8 852.702 1725.6 852.802C1725.8 852.702 1726 852.602 1726.2 852.702Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.3 853.301C1726.2 853.301 1726 853.401 1725.9 853.501C1726 853.401 1726.1 853.301 1726.3 853.301Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.3 854.102C1726.3 854.002 1726.4 853.902 1726.5 853.902C1726.5 853.902 1726.5 853.902 1726.5 854.002C1726.4 854.002 1726.4 854.002 1726.3 854.102Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.6 854.501C1726.6 854.401 1726.7 854.401 1726.7 854.301C1726.7 854.401 1726.7 854.501 1726.6 854.501Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1726.9 854.803C1726.9 854.703 1726.9 854.703 1727 854.703C1727 854.703 1727 854.703 1726.9 854.803Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1727.1 855.204C1727.1 855.104 1727.2 855.104 1727.1 855.204V855.204Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1727.4 855.802C1727.3 855.802 1727.3 855.802 1727.4 855.802C1727.3 855.702 1727.4 855.702 1727.4 855.802Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.5 847.598C1735.6 847.398 1735.6 847.198 1735.7 846.898C1735.9 846.698 1735.9 846.498 1735.7 846.798C1735.7 846.398 1735.7 845.998 1735.8 845.598C1736 845.298 1736 845.198 1735.8 845.498C1735.8 844.998 1736 844.498 1736.3 844.098C1736.6 843.998 1736.7 843.898 1736.3 843.998C1736.6 843.698 1736.9 843.398 1737.2 843.098C1737.5 843.098 1737.7 842.998 1737.3 843.098C1737.6 842.898 1737.9 842.698 1738.1 842.498C1738.3 842.498 1738.5 842.398 1738.1 842.498C1738.3 842.398 1738.8 841.998 1738.7 841.898C1738.5 842.098 1738.3 842.298 1738.1 842.398C1738.3 842.098 1738.1 842.198 1738 842.398C1737.7 842.598 1737.5 842.798 1737.2 842.998C1737.5 842.698 1737.2 842.798 1737.1 843.098C1736.8 843.398 1736.4 843.598 1736.2 843.998C1736.4 843.598 1736.2 843.798 1736.1 844.098C1735.8 844.498 1735.6 844.998 1735.6 845.498C1735.5 845.098 1735.5 845.298 1735.6 845.598C1735.6 845.998 1735.6 846.398 1735.5 846.798C1735.4 846.298 1735.4 846.598 1735.5 846.898C1735.6 847.098 1735.5 847.498 1735.5 847.598Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734 850.099C1733.9 850.099 1733.8 849.999 1733.7 849.999C1734.1 849.799 1733.9 849.799 1733.6 849.999C1733.2 849.999 1732.8 849.699 1732.6 849.399C1733 849.599 1732.8 849.399 1732.6 849.299C1732.4 848.999 1732.2 848.599 1732.1 848.199C1732.4 848.699 1731.8 847.299 1731.9 846.899C1732.1 847.299 1732.1 847.099 1731.9 846.799C1731.8 846.299 1731.7 845.899 1731.4 845.499C1731.8 845.799 1731.7 845.599 1731.3 845.399C1731 844.999 1730.5 844.799 1730.1 844.799C1730.6 844.599 1730.2 844.699 1730 844.799C1729.6 844.899 1729.2 845.099 1729.1 845.399C1729.2 844.799 1728.7 846.399 1729 846.699C1728.7 846.499 1728.9 846.699 1729 846.799C1729.2 847.199 1729.7 847.399 1730.1 847.499C1729.6 847.599 1730 847.599 1730.2 847.499C1730 847.299 1729.8 847.299 1730.1 847.499C1729.7 847.399 1729.3 847.199 1729.1 846.799C1729.1 846.599 1729.1 846.399 1729.1 846.699C1728.9 846.399 1728.9 845.899 1729.1 845.599C1729.4 845.499 1729.5 845.299 1729.1 845.499C1729.4 844.999 1729.9 844.699 1730.4 844.999C1730.5 844.899 1730.2 844.899 1730.1 844.799C1730.5 844.799 1731 844.999 1731.2 845.299C1731.2 845.599 1731.3 845.799 1731.2 845.299C1731.5 845.799 1731.6 846.099 1731.7 846.599C1731.5 846.899 1731.6 846.999 1731.7 846.699C1731.8 847.099 1731.8 847.499 1731.9 847.899C1731.8 848.199 1731.8 848.399 1731.9 847.999C1732 848.399 1732.1 848.799 1732.4 849.199C1732.4 849.499 1732.6 849.699 1732.5 849.299C1732.8 849.599 1733.2 849.799 1733.6 849.899C1733.7 849.999 1733.9 850.099 1734 850.099Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.1 853.3C1735 853.3 1734.9 853.3 1734.7 853.3C1735.1 853 1735.5 852.7 1735.8 852.3C1736.1 852.2 1736.3 851.9 1735.9 852.2C1736.2 851.8 1736.3 851.4 1736.4 851C1736.6 850.8 1736.6 850.5 1736.4 850.9C1736.5 850.6 1736.3 848.9 1736.3 849.6C1736.2 849.2 1735.9 848.8 1735.6 848.4C1735.3 847.9 1735.5 848.1 1735.6 848.4C1735.3 848.1 1735 847.9 1734.6 847.7C1734.5 847.5 1734.2 847.4 1734.5 847.7C1734.2 847.6 1733.9 847.5 1733.6 847.4C1733.4 847.2 1733.1 847.2 1733.5 847.4C1733.1 847.5 1733.3 847.5 1733.6 847.4C1733.9 847.5 1734.2 847.6 1734.5 847.7C1734.1 847.7 1734.3 847.8 1734.6 847.7C1735 847.9 1735.3 848.1 1735.6 848.4C1735.3 848.2 1735.4 848.4 1735.6 848.4C1735.9 848.7 1736.1 849.1 1736.3 849.5C1735.9 848.9 1736.7 850.4 1736.4 850.8C1736.3 850.4 1736.3 850.6 1736.4 850.9C1736.3 851.3 1736.1 851.7 1735.9 852.1C1736 851.6 1735.9 851.8 1735.9 852.2C1735.6 852.6 1735.2 853 1734.8 853.2C1735.2 852.8 1734.9 852.9 1734.7 853.2C1734.2 853.5 1733.7 853.6 1733.2 853.6C1733.6 853.4 1733.4 853.4 1733.1 853.6C1732.6 853.6 1732 853.3 1731.6 853C1732 853.1 1731.8 853 1731.5 852.9C1731.2 852.6 1730.9 852.3 1730.6 851.9C1730.9 852 1730.8 851.9 1730.6 851.8C1730.4 851.5 1730.2 851.2 1730 851C1730.3 851.2 1730.1 851 1729.9 850.9C1729.7 850.6 1729.5 850.4 1729.3 850.1C1729.6 850.3 1729.4 850.1 1729.2 850C1729 849.8 1728.7 849.5 1728.5 849.3C1729 849.4 1728 849.1 1727.8 848.9C1728.2 848.9 1727.9 848.8 1727.7 848.9C1727.6 848.9 1727.5 848.8 1727.4 848.9C1727.6 848.8 1728.2 849.4 1727.9 849C1728.1 849.1 1728.3 849.2 1728.5 849.3C1728.6 849.5 1728.9 849.7 1728.6 849.4C1728.8 849.6 1729.1 849.8 1729.3 850C1729.3 850.3 1729.5 850.5 1729.4 850.1C1729.6 850.3 1729.8 850.6 1730 850.9C1730 851.2 1730.2 851.3 1730 851C1730.2 851.3 1730.4 851.6 1730.6 851.8C1730.6 852.1 1730.8 852.4 1730.6 851.9C1730.9 852.2 1732.1 853.7 1731.6 853C1732 853.3 1732.5 853.6 1733 853.6C1733.3 853.8 1733.7 853.9 1733.1 853.6C1733.6 853.6 1734.2 853.4 1734.6 853.2C1734.8 853.4 1735.1 853.4 1735.1 853.3Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738 841.8C1738.3 841.1 1736.9 841.8 1737.7 841.9C1737.8 842 1737.9 841.9 1738 841.8Z",
    stroke: "#1A2E35",
    strokeWidth: 0.1236,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.1 842.997C1739.1 842.897 1739.1 842.697 1739 842.697C1738.5 842.497 1738.7 843.797 1739.1 842.997Z",
    stroke: "#1A2E35",
    strokeWidth: 0.1236,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.59 829.401L1753.79 841.901C1753.39 842.101 1772.89 810.701 1756.59 820.501C1751.99 823.201 1745.59 829.401 1745.59 829.401Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.99 828.301C1749.79 830.801 1753.29 835.901 1754.69 838.701C1752.79 836.001 1749.19 830.901 1747.99 828.301Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.3 909.704L1661.9 925.504C1659.8 931.404 1658.9 935.304 1656.8 938.304C1655 938.904 1615.2 926.704 1614 925.804C1612.7 924.904 1615.2 921.304 1617.1 920.504C1619 919.704 1636.3 917.604 1636.3 917.604L1654.4 898.004L1676.3 909.704Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1664.2 923.002C1659.3 928.002 1659.8 934.902 1656.8 938.302C1655 938.802 1615.2 926.702 1614 925.802C1612.8 924.902 1615.2 921.302 1617.1 920.502C1619 919.702 1636.3 917.602 1636.3 917.602L1639.3 914.402L1664.2 923.002Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614 925.807C1615.3 926.707 1655.5 938.307 1657.3 937.707C1658 937.507 1661.9 925.607 1661.9 925.507L1636.5 916.707L1636.4 917.107C1636.4 917.107 1619 919.607 1617.1 920.407C1615.1 921.207 1612.7 924.907 1614 925.807Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.2 916.605C1636.7 916.805 1641 918.505 1641.5 920.805C1639.5 919.105 1635.4 918.205 1634.2 916.605Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.9 917.207C1634.4 917.407 1638.7 919.107 1639.2 921.407C1637.2 919.707 1633.1 918.807 1631.9 917.207Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.6 917.906C1632.1 918.106 1636.4 919.806 1636.9 922.106C1635 920.306 1630.8 919.406 1629.6 917.906Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1613.8 924.207C1613 924.307 1612.5 926.707 1612.9 927.107C1613.4 927.407 1657.3 939.907 1658.1 939.907C1658.9 939.907 1659.4 937.207 1658.6 936.807C1657.8 936.407 1613.8 924.207 1613.8 924.207Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1654.4 927.107C1657.7 926.507 1658.7 931.707 1655.4 932.307C1652.1 932.907 1651.1 927.707 1654.4 927.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1661.9 925.607C1661.9 925.707 1658 937.607 1657.3 937.807C1656.1 938.107 1638.9 933.407 1626.5 929.807L1653.5 922.707L1661.9 925.607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1637.2 915.003L1664.5 925.003C1664.5 925.003 1696.7 888.903 1699.2 886.503C1714.4 881.903 1776.2 894.803 1764.2 854.403L1738.8 850.203C1738.8 850.203 1734.6 856.403 1733.3 857.103C1671.2 861.203 1671.3 877.503 1637.2 915.003Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1637.2 915.003L1664.5 925.003C1664.5 925.003 1696.7 888.903 1699.2 886.503C1714.4 881.903 1776.2 894.803 1764.2 854.403L1738.8 850.203C1738.8 850.203 1734.6 856.403 1733.3 857.103C1671.2 861.203 1671.3 877.503 1637.2 915.003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.7 910.102C1651.4 913.002 1659.9 915.802 1667.1 919.302C1659.3 916.602 1650.5 913.702 1643.7 910.102Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694.99 884.002C1697.19 881.202 1739.49 881.102 1751.29 878.002C1760.49 875.002 1760.99 867.302 1761.59 859.502C1761.79 858.502 1761.39 856.802 1761.69 856.102C1761.89 864.002 1761.39 873.902 1753.29 877.802C1747.09 880.702 1699.99 883.002 1698.89 883.102C1696.19 881.202 1667.99 914.602 1666.09 916.102C1665.99 914.402 1694.59 884.602 1694.99 884.002Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.5 908.404L1681.3 926.604C1680.3 932.704 1680.1 936.804 1678.7 940.104C1677 941.004 1635.7 936.404 1634.3 935.704C1632.9 935.104 1634.6 931.104 1636.4 930.004C1638.2 928.904 1654.7 923.604 1654.7 923.604L1668.8 901.004L1692.5 908.404Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.1 923.804C1679.2 929.604 1681 936.304 1678.6 940.204C1676.9 941.004 1635.6 936.504 1634.2 935.804C1632.8 935.204 1634.5 931.204 1636.3 930.104C1638.1 929.004 1654.6 923.704 1654.6 923.704L1656.9 920.004L1683.1 923.804Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1634.2 935.803C1635.6 936.403 1677.3 940.403 1679 939.503C1679.6 939.203 1681.3 926.803 1681.3 926.703L1654.7 922.703V923.203C1654.7 923.203 1638.1 928.803 1636.3 930.003C1634.5 931.103 1632.8 935.103 1634.2 935.803Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.3 923.001C1654.8 922.701 1659.3 923.601 1660.3 925.801C1658 924.401 1653.8 924.301 1652.3 923.001Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.2 924.001C1652.7 923.701 1657.2 924.601 1658.2 926.801C1655.9 925.401 1651.7 925.301 1650.2 924.001Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.1 925.001C1650.6 924.701 1655.1 925.601 1656.1 927.801C1653.8 926.401 1649.6 926.301 1648.1 925.001Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.7 934.203C1632.9 934.403 1632.9 936.903 1633.4 937.203C1633.9 937.503 1679.4 941.503 1680.2 941.403C1681 941.303 1681 938.503 1680.1 938.303C1679.2 938.103 1633.7 934.203 1633.7 934.203Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.2 929.504C1677.4 928.304 1679.3 933.204 1676.1 934.404C1672.9 935.704 1671 930.804 1674.2 929.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.3 920.403L1683.2 925.103C1683.2 925.103 1708.2 890.003 1711.1 887.703C1713.2 886.003 1755 893.003 1763.9 883.603C1769.7 877.503 1767.5 855.003 1767.5 855.003L1738.6 850.203C1738.6 850.203 1738.3 856.303 1739.6 861.603C1739.6 861.603 1702.7 860.603 1694.5 865.403C1685.1 871.003 1655.3 920.403 1655.3 920.403Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1655.3 920.403L1683.2 925.103C1683.2 925.103 1708.2 890.003 1711.1 887.703C1713.2 886.003 1755 893.003 1763.9 883.603C1769.7 877.503 1767.5 855.003 1767.5 855.003L1738.6 850.203C1738.6 850.203 1738.3 856.303 1739.6 861.603C1739.6 861.603 1702.7 860.603 1694.5 865.403C1685.1 871.003 1655.3 920.403 1655.3 920.403Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1735.9 859.305C1739.4 860.805 1743.1 863.405 1745.6 865.905C1742.8 863.405 1738 861.605 1735.9 859.305Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739 851.703C1739.1 853.003 1739.6 863.003 1741.8 858.803C1741.9 857.303 1741.4 853.103 1741.6 852.103C1741.9 853.603 1743.8 860.503 1741 860.503C1741.7 862.703 1740.6 862.603 1740.7 860.503C1738.6 859.703 1738.3 852.803 1739 851.703Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.6 856.402C1753.9 863.802 1758.1 866.202 1763.4 868.702C1757.4 868.602 1752.5 861.802 1754.6 856.402Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.8 916.004C1668.2 917.104 1676.4 917.804 1683.3 919.504C1675.9 918.704 1667.5 917.904 1660.8 916.004Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.3 864.703C1765.1 869.303 1764.5 874.003 1763 878.403C1762.3 880.703 1760.9 882.703 1758.4 883.403C1751.7 885.503 1744.6 885.103 1737.6 885.203C1733 885.103 1728.3 884.903 1723.7 884.703L1716.8 884.403C1714.5 884.303 1712.2 884.203 1709.9 884.503C1709.4 884.603 1709 885.003 1708.5 885.303C1705.6 888.103 1703.1 891.403 1700.6 894.503C1695 901.903 1689.5 909.403 1684.2 916.903C1689.4 909.203 1694.7 901.603 1700.4 894.303C1702.5 891.503 1704.6 888.803 1707 886.203C1707.9 885.403 1708.6 884.303 1709.8 884.003C1713.8 883.403 1719.7 884.103 1723.7 884.103C1728.3 884.303 1733 884.603 1737.6 884.703C1742.2 884.803 1746.9 884.803 1751.5 884.403C1754.3 884.103 1757.3 883.703 1759.9 882.403C1763.8 880.203 1765 869.103 1765.3 864.703Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.3 920.403H1655.4C1657.8 916.303 1660.3 912.303 1662.8 908.303C1671.8 894.503 1680.2 880.103 1691.3 867.803C1692.5 866.503 1693.9 865.303 1695.7 864.703L1696.5 864.403L1697.4 864.203C1702 863.003 1706.7 862.603 1711.4 862.203C1720.8 861.503 1730.3 861.403 1739.7 861.603C1730.3 861.603 1720.8 861.803 1711.4 862.603C1706.7 863.003 1702 863.503 1697.5 864.703L1696.7 864.903L1695.9 865.203C1694.2 865.703 1692.9 866.903 1691.7 868.203C1680.7 880.503 1672.1 894.703 1663.1 908.503C1660.6 912.403 1658 916.503 1655.5 920.403C1655.3 920.403 1656.3 920.403 1656.3 920.403Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.6 872.503C1768.5 872.603 1732.5 856.903 1732.4 856.403C1733.8 855.703 1758.9 806.603 1771.8 820.903C1777.8 834.303 1772 864.103 1768.6 872.503Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1772.3 821.904L1763.8 818.304C1764.7 817.504 1771 820.704 1771.9 821.004C1772 821.304 1772.1 821.604 1772.3 821.904ZM1772.9 823.904L1761.5 819.104C1761.3 819.204 1761 819.404 1760.8 819.504L1773.2 824.704C1773 824.404 1773 824.104 1772.9 823.904ZM1773.5 826.504L1759.3 820.604C1759.1 820.804 1758.9 820.904 1758.7 821.104L1773.6 827.304C1773.6 827.104 1773.5 826.804 1773.5 826.504ZM1773.9 829.104L1757.5 822.304C1757.3 822.504 1757.1 822.604 1757 822.804L1774 829.904C1773.9 829.604 1773.9 829.404 1773.9 829.104ZM1774.1 831.604L1755.8 823.904C1755.6 824.104 1755.5 824.204 1755.3 824.404L1774.2 832.304C1774.1 832.104 1774.1 831.904 1774.1 831.604ZM1774.3 834.104L1754.2 825.704C1754 825.904 1753.9 826.104 1753.7 826.204L1774.3 834.804C1774.3 834.604 1774.3 834.304 1774.3 834.104ZM1774.3 836.504L1752.6 827.504C1752.4 827.704 1752.3 827.904 1752.1 828.004L1774.3 837.204C1774.3 837.004 1774.3 836.804 1774.3 836.504ZM1774.3 838.904L1751.1 829.204C1751 829.404 1750.8 829.604 1750.6 829.804L1774.2 839.604C1774.3 839.404 1774.3 839.204 1774.3 838.904ZM1774.3 841.304L1749.7 831.004C1749.6 831.204 1749.4 831.404 1749.3 831.604L1774.3 842.004C1774.3 841.804 1774.3 841.604 1774.3 841.304ZM1774.2 843.704L1748.3 832.904C1748.2 833.104 1748 833.304 1747.9 833.504L1774.2 844.504C1774.2 844.204 1774.2 843.904 1774.2 843.704ZM1774.1 846.004L1746.9 834.704C1746.8 834.904 1746.6 835.104 1746.5 835.304L1774 846.804C1774 846.504 1774 846.304 1774.1 846.004ZM1773.9 848.304L1745.5 836.504C1745.4 836.704 1745.2 836.904 1745.1 837.104L1773.8 849.104C1773.8 848.804 1773.8 848.604 1773.9 848.304ZM1773.6 850.704L1744.1 838.404C1744 838.604 1743.8 838.804 1743.7 839.004L1773.5 851.404C1773.6 851.104 1773.6 850.904 1773.6 850.704ZM1742.8 840.204C1742.7 840.404 1742.5 840.604 1742.4 840.804L1773.2 853.604C1773.2 853.404 1773.3 853.204 1773.3 852.904L1742.8 840.204ZM1741.5 842.104C1741.4 842.304 1741.2 842.504 1741.1 842.704L1772.8 855.904C1772.8 855.704 1772.9 855.404 1772.9 855.204L1741.5 842.104ZM1740.2 843.904C1740.1 844.104 1739.9 844.304 1739.8 844.504L1772.3 858.104C1772.4 857.904 1772.4 857.604 1772.4 857.404L1740.2 843.904ZM1738.9 845.804C1738.8 846.004 1738.6 846.204 1738.5 846.404L1771.8 860.304C1771.9 860.104 1771.9 859.804 1772 859.604L1738.9 845.804ZM1737.7 847.704C1737.6 847.904 1737.4 848.104 1737.3 848.304L1771.4 862.504C1771.5 862.304 1771.5 862.104 1771.6 861.804L1737.7 847.704ZM1736.4 849.604C1736.3 849.804 1736.1 850.004 1736 850.204L1770.8 864.704C1770.9 864.504 1770.9 864.304 1771 864.004L1736.4 849.604ZM1735.2 851.504C1735.1 851.704 1734.9 851.904 1734.8 852.104L1770.3 866.904C1770.4 866.704 1770.4 866.504 1770.5 866.204L1735.2 851.504ZM1734 853.404C1733.9 853.604 1733.7 853.804 1733.6 854.004L1769.7 869.104C1769.8 868.904 1769.8 868.704 1769.9 868.404L1734 853.404ZM1732.8 855.304C1732.7 855.504 1732.6 855.704 1732.5 855.904L1769.1 871.204C1769.2 871.004 1769.2 870.804 1769.3 870.504L1732.8 855.304Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.4 823.702C1763.7 824.102 1768 822.202 1769.9 819.802C1770 819.602 1770.4 812.202 1770.6 810.802C1770.6 810.502 1761.1 811.602 1761.1 811.602C1761.1 811.602 1761.5 814.802 1761.1 817.302C1760.6 818.802 1760.2 822.802 1762.4 823.702Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.01 810.801C1769.41 813.201 1766.11 819.801 1760.91 818.001C1761.61 815.901 1761.11 811.401 1761.11 811.601C1761.11 811.601 1767.91 810.801 1770.01 810.801Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.2 799.602C1773.8 803.002 1771 812.202 1768.4 814.002C1764.7 816.602 1759.2 816.302 1757 812.002C1755 807.802 1758.8 795.902 1761.7 794.302C1765.8 791.902 1772.3 794.602 1773.2 799.602Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.9 805.602C1764.9 806.202 1764.5 807.002 1765.1 807.402C1764.5 807.302 1764.6 806.102 1764.9 805.602Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.7 805.101C1766.7 805.301 1766.2 807.401 1765.2 807.101C1764.3 807.001 1764.8 805.001 1765.7 805.101Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.1 804.703C1760.8 805.203 1760.7 806.103 1760 806.103C1760.6 806.403 1761.1 805.303 1761.1 804.703Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.7 803.902C1759.7 803.602 1759.1 805.602 1760 805.902C1760.9 806.202 1761.5 804.202 1760.7 803.902Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.5 804.3C1765.2 803.8 1764.4 802.001 1766.5 802.901C1767.1 803.101 1767.6 804.6 1766.5 804.3Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.2 802.602C1761.6 803.002 1763.2 801.802 1761 801.402C1760.3 801.302 1759.1 802.202 1760.2 802.602Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.8 811.202C1763.4 811.602 1762.9 811.402 1762.5 811.102C1762.5 811.702 1763.9 811.802 1763.8 811.202Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.7 809.102C1763 809.802 1761.3 810.002 1760.9 809.202C1761 808.702 1761.3 807.902 1761.3 807.902C1758.7 808.802 1762.2 802.802 1762.7 801.602C1762.6 803.302 1761.2 805.602 1760.7 807.502C1762.4 807.102 1761.5 808.002 1761.3 809.102C1762 809.602 1763 809.102 1763.7 809.102Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772 797.104C1772.8 798.004 1775.7 798.104 1777 796.804C1778.8 795.004 1776.8 791.104 1774.1 791.904C1771.3 792.704 1771.4 796.504 1772 797.104Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.1 793.105C1779.8 796.705 1774.9 799.205 1772 797.105C1774.8 800.105 1780.6 796.705 1777.1 793.105Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1771.6 808.703C1771.5 808.403 1769.7 804.603 1769.1 802.603C1769.1 800.203 1769.7 796.903 1771.4 796.203C1774.4 799.703 1773.1 803.703 1771.6 808.703Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.2 796.103C1773.5 797.203 1766.9 799.803 1769.2 797.303C1768.3 798.503 1764.7 800.303 1762.9 799.503L1764.9 797.903C1764.9 797.903 1761.2 800.103 1759.1 800.103C1757 800.103 1755.7 801.303 1755.7 801.303C1755.7 798.503 1756.8 794.503 1760.3 793.303L1757.7 793.403C1759.4 792.003 1764.3 791.903 1766 792.603L1764.2 791.303C1765.7 790.603 1770.2 792.903 1770.9 793.703L1769.6 792.303C1771.4 792.403 1772.3 794.903 1772.2 796.103Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.6 809.901C1765 808.401 1762.8 807.601 1760.9 808.001C1758.4 808.301 1758.7 813.401 1759.3 814.601C1760.2 816.201 1765.1 816.901 1766.3 815.501C1767 815.101 1766 810.801 1765.6 809.901ZM1764.3 812.301C1763.7 812.801 1760.9 812.601 1760.4 812.001C1760.1 811.301 1759.8 808.501 1761.2 808.401C1763.7 807.701 1764.8 810.601 1764.3 812.301Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.2 807.101C1770.2 807.101 1772.7 804.401 1774 805.301C1775.8 807.101 1770.7 813.601 1769.3 809.601L1770.2 807.101Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.41 806.402C1772.31 806.802 1771.41 807.702 1770.91 808.702C1771.31 808.302 1771.81 808.202 1772.31 808.602C1771.51 808.402 1770.81 808.902 1770.41 809.702C1769.81 808.802 1772.01 806.202 1773.41 806.402Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.3 875.805H1723.6V883.005H1742.3V875.805Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1742.3 882.903L1768.8 870.903V863.703L1742.3 875.803V882.903Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.6 875.803L1750.1 863.703H1768.8L1742.3 875.803H1723.6Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.9 863.703H1768.8V870.903H1781.9V863.703Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.1 824.604C1776.1 858.004 1778.3 860.604 1750.3 870.104C1748.2 870.704 1740.6 858.504 1742.4 857.104C1745.1 855.004 1761.1 847.804 1761.4 847.104C1761.5 848.004 1768.7 808.304 1773.1 824.604Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.4 856.404C1718 855.004 1716.8 894.204 1727.7 869.904C1719.5 884.904 1728.7 882.204 1731.9 870.304C1724.3 884.604 1732.5 882.404 1736.2 871.204C1728.6 886.404 1738.7 878.904 1741.1 872.004C1747.7 872.904 1751.2 870.704 1753.6 868.804C1754 868.304 1744.4 856.404 1744.4 856.404Z",
    fill: "#ED776A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.4 866.605C1727.6 868.705 1724.4 876.105 1724.4 877.605C1725.9 872.805 1727.8 870.105 1729.4 866.605Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1733.3 868.707C1731.8 871.207 1729.8 874.507 1729 876.907C1730.5 874.107 1732 871.307 1733.3 868.707Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737 869.805C1735.8 871.605 1734.3 874.605 1733.9 876.205C1734.8 874.105 1736 872.105 1737 869.805Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.1 838.104L1777 843.404C1776.7 843.804 1774.3 806.904 1766.7 824.404C1764.7 829.404 1763.1 838.104 1763.1 838.104Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.4 835.805C1767.3 836.805 1773.2 838.905 1775.9 840.305C1772.8 839.305 1766.9 837.205 1764.4 835.805Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.09 825.401C1768.19 814.501 1770.69 842.101 1771.39 850.801C1771.19 854.501 1768.19 856.001 1772.29 858.601C1777.99 863.101 1793.59 861.301 1795.39 854.501C1792.69 850.901 1794.29 826.501 1786.09 825.401Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.4 851.703C1792.2 845.503 1795.6 824.703 1786.2 825.703C1792.6 825.803 1792.5 834.803 1793.4 843.603C1793.5 848.203 1797.2 853.203 1793.7 857.303C1795.1 856.303 1795.8 853.603 1795.4 851.703Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.8 827.101C1780.6 822.601 1772.5 824.901 1771.3 831.901C1770.4 838.501 1771.9 849.001 1769.2 855.301C1769.3 856.501 1770.9 857.301 1771.7 857.101C1768.7 856.601 1769.4 854.501 1770.2 852.601C1772.5 847.701 1770.5 837.701 1771.4 832.601C1772.5 825.001 1780.2 823.001 1785.8 827.101Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.9 824.999C1786.2 825.699 1789.8 824.699 1790.9 822.499C1792.4 819.599 1788.3 815.699 1785.2 817.799C1782.1 819.899 1783.8 824.399 1784.9 824.999Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.4 818C1794.2 821.2 1789.4 826.3 1784.9 825C1789.6 827.4 1795.2 820.8 1789.4 818Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.9 834.898C1767.9 830.698 1775.5 836.898 1773.3 844.798C1771.3 854.098 1771.3 864.598 1777 870.398",
    stroke: "#1A2E35",
    strokeWidth: 0.3709,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790 849.698C1774.3 865.798 1773.7 870.898 1755.6 860.698C1754.4 860.098 1761.1 847.098 1763.5 848.398C1767.1 850.398 1769.1 851.798 1770.3 851.898C1771.3 851.998 1777.2 848.598 1787.4 844.598C1792.9 842.398 1792.7 846.898 1790 849.698Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.5 854.999C1750.5 857.299 1756.5 861.599 1758.2 861.799C1759.9 861.999 1765.5 852.199 1764.8 850.599C1764.1 848.999 1757.5 841.499 1754.4 840.999C1751.3 840.499 1746.4 852.699 1748.5 854.999Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.4 861.601L1761.8 864.101L1768.5 851.001L1765.5 848.801L1757.4 861.601Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.87 844.837L1750.07 854.77L1751.62 855.677L1757.42 845.744L1755.87 844.837Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.39 857.201L1749.59 856.701L1750.19 854.801L1751.79 855.801L1750.39 857.201Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1749.9 856.898L1750.1 856.998L1748.7 859.298L1749.9 856.898Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.25 843.454L1752.94 845.699L1758.29 848.824L1759.6 846.578L1754.25 843.454Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.64 846.161L1751.33 848.406L1756.68 851.531L1757.99 849.285L1752.64 846.161Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.04 848.883L1749.73 851.129L1755.08 854.254L1756.39 852.008L1751.04 848.883Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.67 834.164L1755.72 844.355L1758.14 845.767L1764.08 835.575L1761.67 834.164Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.69 836.1L1763.04 837.223L1771.24 842.011L1771.9 840.888L1763.69 836.1Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.5 843.35L1758.84 844.473L1767.05 849.261L1767.7 848.138L1759.5 843.35Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.48 837.512L1759.91 843.645L1763.45 845.711L1767.03 839.579L1763.48 837.512Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1763.48 837.512L1759.91 843.645L1763.45 845.711L1767.03 839.579L1763.48 837.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1764.04 837.79L1760.46 843.922L1761.41 844.476L1764.99 838.344L1764.04 837.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.19 839.579L1763.61 845.711L1767.15 847.777L1770.73 841.645L1767.19 839.579Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1767.19 839.579L1763.61 845.711L1767.15 847.777L1770.73 841.645L1767.19 839.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1767.66 839.883L1764.08 846.016L1765.03 846.57L1768.61 840.438L1767.66 839.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.9 842.7C1759.2 844.3 1757.2 843.7 1757.2 843.7C1759.3 844.4 1761.5 849 1756.7 847.8C1759.2 848.7 1760.1 853.5 1755.8 851.6C1755.9 851.7 1757.4 853.3 1756.7 854.5C1755.5 856.6 1751.7 852.6 1749.8 852.7C1749.8 852.7 1748.7 855.1 1748.7 855.2C1748.5 855.4 1743.5 849 1747.2 848.2C1746.3 847.7 1745.4 845.1 1747.7 844.7C1746.6 844 1746.9 841.5 1748.6 841.5C1746.4 836.3 1758.1 838.9 1758.9 842.7Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.7 841.5C1751.2 841.3 1755.7 842.2 1757.2 844C1754.4 842.7 1751.8 841.8 1748.7 841.5Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747.59 844.699C1750.19 844.399 1754.89 845.699 1756.79 847.899C1754.89 846.599 1750.29 845.099 1747.59 844.699Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.9 851.901C1753.4 849.801 1750.1 848.901 1747.2 848.201C1750.3 848.101 1754.4 849.401 1755.9 851.901Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.2 843.699C1760.5 845.399 1760.2 849.199 1756.1 847.299C1760.1 849.699 1759.3 853.799 1754.6 850.599C1755.5 851.599 1757.9 853.699 1756.1 854.799C1753.9 855.099 1752 852.799 1749.8 852.699C1752.1 853.099 1753.7 855.499 1756.2 855.199C1758 854.499 1757 852.299 1756.1 851.399L1755.8 851.799C1759.4 853.899 1760.5 849.499 1757.5 847.699L1757.3 848.099C1761.2 848.899 1759.9 844.599 1757.2 843.699Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.6 852.098C1764.6 852.098 1765.9 850.298 1765.6 849.098C1757.1 823.898 1747 859.598 1757.5 845.598C1758.4 850.998 1762.3 849.198 1764.6 852.098Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.7 840.199C1754.6 842.299 1752.5 845.399 1752.5 848.499C1754.3 850.699 1756.8 847.299 1757.6 845.699L1757.2 845.599C1757.6 847.499 1758.8 849.499 1760.8 850.099C1758.8 849.199 1757.9 846.999 1757.6 844.999C1750.9 854.199 1753 843.999 1756.7 840.199Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.09 851.898C1771.79 853.398 1773.19 855.298 1773.89 857.498C1772.59 855.598 1771.29 853.798 1770.09 851.898Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.79 861.398L1773.59 850.398C1805.09 834.398 1790.79 851.198 1778.79 861.398Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.1 858.696C1778.1 853.996 1776.2 850.596 1775.7 849.996C1776.1 850.596 1778.1 855.496 1780.1 858.696Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1791.19 848.697C1786.89 854.497 1778.79 861.397 1778.79 861.397L1774.59 852.397L1788.49 843.997C1791.89 843.097 1794.89 843.697 1791.19 848.697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787.5 972.5L1743.2 972.6L1743.3 974.6L1787.7 974.8L1787.5 972.5Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1787.5 972.5L1743.2 972.6L1743.3 974.6L1787.7 974.8L1787.5 972.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1743.6 972.899C1742.2 972.399 1743.5 968.299 1745 967.099C1747.8 964.999 1762.8 959.099 1762.7 959.199L1757.4 939.699L1780.7 939.199C1780.7 939.199 1787.7 959.199 1787.7 959.299C1787.5 966.399 1788.1 972.199 1787.5 972.499C1786 973.499 1745 973.399 1743.6 972.899Z",
    fill: "#FFC4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.4 947.098L1759.2 946.898L1762.8 959.098C1762.9 958.998 1748 964.898 1745.1 966.998C1743.5 968.298 1742.2 972.398 1743.7 972.798C1745.1 973.298 1786.1 973.398 1787.6 972.398C1788.2 971.998 1787.8 958.998 1787.8 958.898C1787.6 958.098 1784.4 947.098 1784.4 947.098Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.1 953.897C1765.8 953.397 1769.3 953.896 1770.3 956.096C1768.5 954.896 1765.3 955.097 1764.1 953.897Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.3 955.498C1765 954.998 1768.5 955.498 1769.5 957.698C1767.7 956.498 1764.4 956.698 1763.3 955.498Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.5 957.1C1764.2 956.6 1767.7 957.1 1768.7 959.3C1766.9 958.1 1763.6 958.2 1762.5 957.1Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.7 958.697C1763.4 958.197 1766.9 958.697 1767.9 960.897C1766 959.697 1762.8 959.797 1761.7 958.697Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.6 959.799C1761.3 959.299 1764.8 959.799 1765.8 961.999C1764 960.799 1760.7 960.999 1759.6 959.799Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.1 960.998C1758.8 960.498 1762.3 960.998 1763.3 963.198C1761.4 961.998 1758.2 962.098 1757.1 960.998Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.6 962.197C1756.3 961.697 1759.8 962.197 1760.8 964.397C1758.9 963.097 1755.7 963.297 1754.6 962.197Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.5 951.898C1762.3 952.898 1766.1 954.998 1767.8 954.298C1764.8 944.398 1754.8 946.198 1760.5 951.898ZM1759.7 949.698C1759.8 944.098 1766.7 952.198 1767.5 953.998C1765.1 952.798 1760.9 952.598 1759.7 949.698Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777 949.699C1774.2 945.799 1768.6 951.599 1767.3 954.299C1769.3 955.299 1778.3 953.699 1777 949.699ZM1771.2 953.399C1770 953.599 1768.8 953.699 1767.7 953.899C1775.4 944.699 1781 951.899 1771.2 953.399Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758 944.2L1782.7 944C1782.7 944 1774.6 916.2 1775.9 912.8C1787 902.4 1820.3 899.3 1805 874.5H1782.3C1782.3 874.5 1783.8 879.5 1780.8 884.4C1740 898.8 1748.2 911 1758 944.2Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 938.302C1773 938.102 1765.2 937.902 1758.5 938.602C1765.5 938.802 1773.3 939.202 1780 938.302Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1804 896.7C1792.8 903.9 1771.5 912.2 1751.9 922.4C1750.2 914.4 1749.3 906.3 1751.3 902.4C1755.7 893.8 1781 884.4 1781 884.4C1784 879.5 1782.5 874.5 1782.5 874.5H1805.2C1805.1 874.5 1814 887.9 1804 896.7Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.1 917.001C1768.4 898.801 1814.5 903.901 1802.6 876.801C1812.5 899.101 1780.7 899.201 1771.6 911.401C1770.8 918.301 1774.2 927.501 1777 936.601C1777 936.601 1774.2 928.801 1772.1 917.001Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.39 906.699H1787.59V970.899H1791.39V906.699Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1809.7 898.301H1769.3V906.701H1809.7V898.301Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.2 916.799H1785.9L1785.4 906.699H1793.7L1793.2 916.799Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.9 950.699H1786.2V970.899H1792.9V950.699Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.2 970.902H1777.8V974.502H1801.2V970.902Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.2 955.301H1765.8V957.601H1786.2V955.301Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1729.8 972.5L1685.5 972.6L1685.6 974.6L1730 974.8L1729.8 972.5Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1729.8 972.5L1685.5 972.6L1685.6 974.6L1730 974.8L1729.8 972.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1685.9 972.899C1684.5 972.399 1685.8 968.299 1687.3 967.099C1690.1 964.999 1705.1 959.099 1705 959.199L1712.5 939.699L1738 939.199C1738 939.199 1731.1 957.499 1731 958.999C1730.8 965.799 1730.4 972.299 1729.8 972.499C1728.3 973.499 1687.3 973.399 1685.9 972.899Z",
    fill: "#FFC4C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.6 948.5L1709.7 947L1705 959.2C1705.2 959.1 1690.1 965 1687.3 967.1C1685.7 968.4 1684.4 972.5 1685.9 972.9C1687.3 973.4 1728.3 973.5 1729.8 972.5C1730.4 972.3 1730.8 965.8 1731 959C1731.1 958.6 1733.8 950.3 1734.6 948.5Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.5 953.897C1708.2 953.397 1711.7 953.896 1712.7 956.096C1710.8 954.896 1707.6 955.097 1706.5 953.897Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.6 955.498C1707.3 954.998 1710.8 955.498 1711.8 957.698C1710 956.498 1706.7 956.698 1705.6 955.498Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.8 957.1C1706.5 956.6 1710 957.1 1711 959.3C1709.2 958.1 1705.9 958.2 1704.8 957.1Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704 958.697C1705.7 958.197 1709.2 958.697 1710.2 960.897C1708.3 959.697 1705.1 959.797 1704 958.697Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.9 959.799C1703.6 959.299 1707.1 959.799 1708.1 961.999C1706.3 960.799 1703 960.999 1701.9 959.799Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1699.4 960.998C1701.1 960.498 1704.6 960.998 1705.6 963.198C1703.7 961.998 1700.5 962.098 1699.4 960.998Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.9 962.197C1698.6 961.697 1702.1 962.197 1703.1 964.397C1701.2 963.097 1698 963.297 1696.9 962.197Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.8 951.898C1704.6 952.898 1708.4 954.998 1710.1 954.298C1707.1 944.398 1697.1 946.198 1702.8 951.898ZM1702.1 949.698C1702.2 944.098 1709.1 952.198 1709.9 953.998C1707.4 952.798 1703.2 952.598 1702.1 949.698Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1719.29 949.699C1716.49 945.799 1710.89 951.599 1709.59 954.299C1711.59 955.299 1720.59 953.699 1719.29 949.699ZM1713.49 953.399C1712.29 953.599 1711.09 953.699 1709.99 953.899C1717.69 944.699 1723.29 951.899 1713.49 953.399Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.2 944.1L1736.1 946.1C1736.1 946.1 1756.3 914.5 1758.1 912.7C1762.2 908.6 1797.7 902.8 1806.9 894.3C1813.2 888.5 1807.9 874.5 1807.9 874.5H1781.7C1781.7 874.5 1782 878.2 1780.7 878.6C1731.1 893.1 1725.7 909.4 1710.2 944.1Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737 940.399C1730.1 939.499 1722.4 938.599 1715.7 938.699C1722.7 939.499 1730.2 940.599 1737 940.399Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1805.3 875.699C1815.1 892.099 1793.9 897.599 1781.9 901.299C1773.7 903.999 1764.5 905.899 1756.3 908.699C1749.2 917.899 1747 922.599 1738.4 937.099C1744.5 926.999 1751.9 914.499 1756.6 909.099C1770.5 902.899 1819.7 899.299 1805.3 875.699Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.4 844.096C1790.1 847.596 1787.3 855.196 1784 846.496L1783.8 846.196L1780.5 841.996C1780.8 841.496 1784.7 835.196 1784.9 834.996C1785.8 836.096 1790.2 842.896 1790.4 844.096Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.7 837.698C1787.1 842.098 1784.9 844.998 1783.7 846.198L1780.4 841.998C1780.7 841.498 1784.6 835.198 1784.8 834.998C1784.9 834.898 1785.7 836.198 1786.7 837.698Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.9 836.001C1772.1 849.701 1787.6 848.501 1787.6 835.001C1787.9 818.501 1768.9 819.701 1770.9 836.001Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.79 836.2C1784.79 836.3 1784.39 831.8 1784.39 831.8C1784.39 831.8 1780.99 831.4 1779.49 829.2C1779.49 829.2 1780.59 831.1 1781.89 831.8C1782.09 831.9 1775.29 831.7 1774.29 826.6C1774.29 826.6 1773.69 831.8 1770.69 833C1770.19 832.3 1772.09 826.1 1773.59 825.3C1780.69 818.3 1793.29 828.8 1786.79 836.2Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.69 831.999C1777.69 832.299 1774.99 829.399 1774.19 826.199C1773.79 829.999 1778.69 832.699 1781.69 831.999Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.69 835.998C1784.59 835.098 1784.19 833.098 1783.89 831.098C1783.49 832.398 1784.99 836.398 1786.69 835.998Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.19 825.801C1773.89 828.001 1773.79 831.501 1771.39 832.401C1773.99 831.901 1774.69 828.001 1774.19 825.801Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.79 836.1C1772.79 836.3 1773.99 835.3 1772.29 835.2C1771.79 835.1 1770.99 835.9 1771.79 836.1Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.19 834.498C1777.79 834.498 1777.29 834.598 1776.89 834.298C1776.29 833.098 1779.59 833.798 1778.19 834.498Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.2 837C1777.4 837.5 1777.4 838.4 1778.1 838.5C1777.5 838.7 1777.1 837.6 1777.2 837Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.59 836.299C1778.59 836.099 1778.99 838.099 1778.09 838.299C1777.19 838.499 1776.79 836.499 1777.59 836.299Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.09 836.3C1778.49 836.6 1778.99 836.6 1779.19 836C1779.69 837.3 1777.79 837.3 1778.09 836.3Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.69 837.602C1773.69 838.102 1773.89 839.002 1773.29 839.302C1773.99 839.302 1773.89 838.102 1773.69 837.602Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.99 837C1771.99 837.1 1772.29 839.1 1773.19 839C1774.19 838.9 1773.89 836.9 1772.99 837Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.59 837.199C1772.29 837.599 1771.89 837.799 1771.49 837.299C1771.39 838.499 1773.09 838.099 1772.59 837.199Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.19 842.199C1777.99 842.699 1777.49 842.799 1777.09 842.699C1777.29 843.199 1778.59 842.699 1778.19 842.199Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.19 840.299C1775.29 840.199 1774.99 841.899 1775.59 841.699C1776.29 841.699 1777.49 841.099 1777.39 840.499C1776.89 840.999 1776.29 841.299 1775.59 841.399C1775.39 840.399 1775.99 839.199 1774.59 840.199C1774.39 838.299 1774.89 835.799 1774.39 834.199C1774.29 835.499 1773.19 841.999 1775.19 840.299Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1778.7 840.299C1774.8 840.299 1775 834.199 1778.8 834.399C1782.7 834.399 1782.6 840.499 1778.7 840.299ZM1776.2 837.299C1776.1 840.599 1781.3 840.699 1781.3 837.399C1781.5 834.099 1776.3 833.899 1776.2 837.299Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.5 840.999C1769.8 841.299 1768.8 835.599 1771.8 835.099C1774.8 834.899 1775.3 840.699 1772.5 840.999ZM1770.69 836.399C1769.79 837.799 1770.8 840.899 1772.5 840.599C1775.6 840.199 1773.29 832.999 1770.69 836.399Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.99 837.599L1776.19 837.299C1775.69 836.999 1774.59 836.6 1773.99 837.4L1774.29 837.599C1774.79 836.899 1775.89 837.599 1775.99 837.599Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.2 836.9L1789.5 836.7C1788.6 833.9 1782.7 836.2 1781.3 836.3L1781.4 836.7C1784.2 836.3 1787.9 834.2 1789.2 836.9Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.99 835.899C1785.99 835.899 1787.39 832.598 1788.89 833.098C1791.09 834.098 1788.49 841.598 1785.99 838.498V835.899Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.69 834.398C1787.89 835.098 1787.29 836.198 1787.19 837.298C1787.39 836.898 1788.09 836.398 1788.39 836.898C1787.49 836.798 1787.19 837.698 1787.09 838.398C1786.19 837.698 1787.29 834.598 1788.69 834.398Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1808.9 874.4H1781.7L1780.8 865.1C1780.8 865.1 1778.4 862 1778.9 859.5C1781.7 852 1786.4 839.2 1793.5 844.5C1800.4 851.3 1808.9 874.4 1808.9 874.4Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.39 847.398C1782.09 849.498 1765.59 864.098 1764.39 865.598C1762.59 907.598 1802.99 832.398 1784.39 847.398Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.4 865.701C1772.9 865.501 1771.5 858.901 1774 863.801C1774 863.601 1773.9 862.001 1774.4 861.801C1775.2 861.501 1775.1 865.601 1774.4 865.701Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.09 860.7C1773.29 860.1 1774.89 855.6 1774.49 859.4C1774.59 859.3 1775.09 858.3 1775.49 858.4C1776.09 858.6 1774.49 860.9 1774.09 860.7Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.8 862.699C1782.7 862.199 1782.2 861.899 1781.8 861.999C1782.6 860.399 1780.6 861.199 1779.8 861.899C1781.3 860.999 1782 856.399 1779.5 858.899C1778.3 856.499 1778 860.299 1778.4 861.299C1778.3 860.099 1776.2 858.299 1776.4 860.499C1774.7 860.299 1775.7 862.199 1776.8 862.399C1779.7 864.399 1776.9 867.399 1775.6 869.399C1777.5 863.099 1773.8 866.499 1775.2 870.399C1774.9 871.499 1774.9 872.699 1775.5 873.799L1775.6 873.699C1775.1 872.199 1775.2 870.399 1776.1 869.099C1777.1 867.999 1779.7 868.299 1780 866.699C1779.2 865.799 1777.7 867.399 1777 867.899C1778.4 865.699 1779 863.199 1782.2 863.899C1782.3 863.799 1782.3 863.699 1782.4 863.599C1781.3 863.899 1780.1 863.599 1779 863.599C1779.9 862.999 1781 862.999 1781.8 862.799C1780.8 862.599 1779.7 862.899 1779 863.499C1779.6 862.899 1780.4 862.499 1781.1 862.299C1780.3 862.399 1779.5 862.699 1779 863.399C1778.8 862.499 1782.7 860.199 1781.8 862.099C1781.8 862.199 1781.8 862.199 1781.9 862.199C1782.4 862.099 1782.9 862.399 1782.8 862.999C1782.7 862.899 1782.7 862.799 1782.8 862.699ZM1775.7 866.599C1775.3 867.599 1775.1 868.999 1775.2 870.199C1774.4 865.899 1777.2 864.099 1775.3 869.799C1775.2 868.699 1775.8 867.399 1775.7 866.599ZM1778 867.199C1778.4 866.699 1780.6 866.199 1779.4 867.299C1778.5 867.899 1777.4 868.199 1776.4 868.699C1777.1 867.799 1778.6 867.499 1779.3 866.899C1778.3 867.199 1777.4 867.699 1776.6 868.299C1776.9 867.999 1777.5 867.599 1778 867.199ZM1777.5 862.699C1777 862.099 1775.7 861.999 1775.6 860.999C1775.7 860.499 1776.2 860.599 1776.5 860.699C1776.6 860.699 1776.6 860.699 1776.6 860.599C1776.3 857.499 1779 861.999 1778.5 863.099C1778.3 862.399 1777.8 861.399 1777.3 861.199C1777.7 861.699 1778.1 862.299 1778.3 862.999C1778 862.299 1777.5 861.799 1776.9 861.399C1777.3 861.899 1778 862.599 1778.3 863.399C1778 863.299 1777.7 862.799 1777.5 862.699ZM1779.6 863.799C1779 863.999 1778.5 864.599 1778.2 865.099C1778.3 864.399 1778.1 863.699 1777.8 863.199C1778.1 863.399 1778.4 863.699 1778.6 863.299C1778.7 863.799 1779.2 863.899 1779.6 863.799ZM1779.3 862.199C1779.2 862.399 1779 862.599 1778.8 862.799C1779.2 861.899 1779.7 860.599 1779.6 859.699C1779.4 860.699 1779.1 861.599 1778.8 862.499C1779.4 859.399 1778.9 859.999 1778.7 862.599C1778.4 861.799 1778 856.299 1779.4 859.199C1779.7 859.399 1780.4 857.699 1780.9 858.599C1781.4 859.999 1780 861.199 1779.3 862.199Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.39 864.699L1773.99 855.899C1798.79 830.799 1790.49 851.299 1782.39 864.699Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.79 861.798C1779.39 857.998 1776.49 855.298 1775.79 854.898C1776.39 855.398 1779.79 859.398 1782.79 861.798Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.59 863.898L1782.39 864.698C1783.99 861.398 1786.29 857.698 1787.89 854.198C1788.49 852.998 1788.99 851.798 1789.49 850.598C1789.19 851.898 1788.69 853.098 1788.19 854.298C1786.59 857.998 1784.69 861.498 1782.49 864.798L1781.59 863.898Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.79 851.199C1789.49 851.799 1789.09 852.299 1788.59 852.799C1788.99 852.199 1789.39 851.699 1789.79 851.199Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.09 861.5C1755.29 861.5 1749.69 875.6 1752.19 876.2C1763.89 879 1766.99 878.9 1769.99 878.4C1773.09 877.8 1774.29 871.5 1773.29 869.7C1771.89 867 1758.79 861.5 1757.09 861.5Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1759.19 862.7C1739.69 845.1 1718.99 872.7 1739.59 861.5C1737.29 865.3 1738.99 869.3 1742.59 873.7C1742.59 873.7 1743.09 873.5 1743.69 873.1C1743.69 873.1 1748.39 876.7 1752.09 876.3L1759.19 862.7Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.6 857.7C1746 857.6 1732 863.8 1733.2 869.3C1734.2 871.2 1736.8 869.6 1736.8 869.6C1734.7 871.4 1735.3 875.7 1739 873.6C1739 873.6 1737.9 875.3 1739.3 876.4C1741 877.7 1742.9 873.9 1745.8 873.8C1746.4 873.8 1750.6 857.7 1750.6 857.7Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744 863.699C1742.2 864.299 1738.6 866.599 1736.7 869.599C1739.2 867.199 1742.9 864.399 1744 863.699Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.8 867.301C1744.3 867.901 1740.6 870.501 1738.8 873.601C1741.4 871.001 1744.7 868.001 1745.8 867.301Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.4 861.5L1761.9 862.7L1756.8 877.6L1752.2 876.3L1757.4 861.5Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.99 867.6C1767.99 865.8 1764.79 864.2 1761.59 863.1C1761.59 863 1761.69 862.7 1761.79 862.6L1761.99 862.9C1760.79 862.9 1759.59 862.5 1758.49 862C1751.19 857.7 1747.59 855.1 1738.79 857.8C1737.69 858.1 1736.59 858.6 1735.49 859C1736.59 858.5 1737.59 858 1738.79 857.6C1747.39 854.5 1751.59 857.1 1758.69 861.6C1759.79 862.2 1760.99 862.5 1762.29 862.5C1762.29 862.6 1762.09 862.9 1762.09 863.1L1761.99 862.8C1765.09 864 1768.19 865.7 1770.99 867.6Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.4 870.198C1762.4 870.198 1761.8 869.898 1761.5 869.898L1761.6 870.598L1761.4 870.298V870.798L1762.4 870.198Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.3 873.098C1763.3 873.098 1765.1 872.498 1766 871.298C1767.1 871.398 1770.9 869.498 1771.5 868.398C1771.6 871.398 1768.1 875.798 1763.5 874.798L1763.3 873.098Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.59 873.698C1764.09 874.298 1766.19 872.198 1766.39 871.898C1766.29 872.198 1765.69 874.098 1766.09 874.398C1766.09 873.998 1766.49 872.298 1766.59 871.998C1766.79 872.598 1767.59 873.598 1768.29 873.498C1768.39 873.498 1767.49 873.098 1767.39 872.898C1767.29 872.798 1766.79 871.798 1766.79 871.798C1767.19 872.198 1769.19 872.498 1769.69 872.198C1769.29 872.198 1767.29 871.998 1766.99 871.598C1766.99 871.598 1768.49 871.398 1768.99 871.098C1769.69 870.698 1771.29 868.998 1770.89 869.098C1770.69 869.198 1769.39 870.598 1768.89 870.898C1768.39 871.098 1766.69 871.598 1766.59 871.298C1766.49 871.298 1766.39 871.498 1766.39 871.498C1766.29 871.398 1766.09 871.498 1766.19 871.698C1765.99 872.098 1764.09 873.498 1763.59 873.698Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 874.297C1764.8 874.397 1764.6 874.097 1764.8 873.997C1765.1 873.897 1765.2 874.197 1765 874.297Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.5 873.999C1765.3 874.099 1765.2 873.799 1765.4 873.699C1765.5 873.699 1765.7 873.899 1765.5 873.999Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.2 873.697C1765.1 873.897 1764.8 873.797 1764.9 873.597C1765.1 873.397 1765.3 873.497 1765.2 873.697Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.9 873.597C1765 873.797 1764.7 873.897 1764.6 873.697C1764.5 873.497 1764.8 873.397 1764.9 873.597Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.5 873.797C1764.7 873.897 1764.6 874.197 1764.4 874.097C1764.2 873.997 1764.3 873.697 1764.5 873.797Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.4 874.196C1764.6 874.096 1764.7 874.396 1764.5 874.496C1764.4 874.596 1764.2 874.296 1764.4 874.196Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.6 874.597C1764.7 874.397 1765 874.497 1764.9 874.697C1764.8 874.897 1764.6 874.797 1764.6 874.597Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 874.596C1764.9 874.396 1765.2 874.296 1765.3 874.496C1765.4 874.696 1765.1 874.896 1765 874.596Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.4 874.398C1765.2 874.298 1765.3 873.998 1765.5 874.098C1765.7 874.198 1765.6 874.498 1765.4 874.398Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.5 874.198C1766.3 874.198 1766.2 873.498 1766.4 873.398C1766.5 873.498 1766.6 874.098 1766.5 874.198Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.8 873.797C1767.6 873.897 1767.2 873.497 1767.2 873.297C1767.3 873.297 1767.8 873.697 1767.8 873.797Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767 873.798C1766.7 873.698 1766.4 872.698 1766.6 872.398C1766.8 872.498 1767.1 873.598 1767 873.798Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.2 874.098C1767.1 874.298 1766.8 874.098 1766.9 873.898C1767 873.798 1767.3 873.998 1767.2 874.098Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770 871.997C1769.9 872.197 1769.3 872.197 1769.3 871.997C1769.4 871.897 1770 871.897 1770 871.997Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.9 870.898C1770 871.098 1769.5 871.498 1769.3 871.398C1769.3 871.198 1769.8 870.898 1769.9 870.898Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.2 871.698C1769 871.998 1768.1 872.098 1767.8 871.798C1767.9 871.698 1769 871.598 1769.2 871.698Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.7 870.398C1770.9 870.698 1770.4 871.598 1770 871.598C1770 871.398 1770.5 870.398 1770.7 870.398Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.7 871.5C1769.9 871.6 1769.6 871.9 1769.5 871.7C1769.4 871.6 1769.6 871.4 1769.7 871.5Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.1 872.798C1769 872.998 1768.5 872.998 1768.4 872.798C1768.5 872.698 1769 872.698 1769.1 872.798Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.59 873.199C1768.29 873.299 1767.49 872.799 1767.59 872.499C1767.69 872.399 1768.49 872.999 1768.59 873.199Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.89 873.298C1768.89 873.498 1768.59 873.498 1768.59 873.298C1768.59 873.098 1768.89 873.098 1768.89 873.298Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.8 875.797C1772 878.497 1768.1 878.197 1765.6 877.297C1766.3 877.897 1768.2 878.597 1769.5 878.597C1766.7 879.097 1764.3 878.797 1761.4 878.297C1755 871.997 1766.9 866.297 1764 873.897C1765.1 874.297 1767.1 874.297 1768.1 873.897C1769.6 874.897 1771.9 875.397 1773.8 875.797Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.4 874.099C1759.5 874.899 1759.6 873.299 1760.1 873.199C1760.3 873.199 1760.2 873.599 1760.2 873.599C1760.5 873.199 1761 873.699 1760.4 874.099Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1761.29 871.299C1760.89 872.699 1761.99 873.899 1763.29 873.699C1765.59 872.099 1762.89 869.299 1761.29 871.299Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.09 871.099C1762.69 870.399 1761.39 871.099 1761.89 871.799C1762.29 872.499 1763.59 871.799 1763.09 871.099Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1762.8 874.3C1761.9 874.5 1760.9 873.8 1760.7 873C1760.6 873.5 1761.4 874.4 1761.8 874.6C1762.1 874.6 1763.3 874.7 1762.8 874.3Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763 875.099C1762.1 875.499 1760.9 875.099 1760.4 874.199C1760.4 874.699 1761.4 875.599 1761.9 875.699C1762.3 875.699 1763.5 875.499 1763 875.099Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.8 876.898C1763 877.498 1761.6 877.198 1760.9 876.598C1761.4 877.498 1763.2 877.998 1764 877.198C1764 877.098 1763.9 876.898 1763.8 876.898Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.4 877.598C1763.8 878.298 1762.5 878.198 1761.8 877.898C1762.1 878.198 1763.4 878.498 1763.9 878.398C1764.1 878.298 1765 877.698 1764.4 877.598Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.19 878.4C1765.19 878.5 1765.09 878.6 1764.99 878.7C1764.89 878.7 1764.69 878.7 1764.49 878.7C1764.69 878.4 1765.09 877.9 1765.19 878.4Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.3 876.099C1762.2 876.599 1760.7 876.199 1760.2 875.199C1760.3 876.399 1762.4 877.199 1763.3 876.499C1763.5 876.299 1763.4 876.099 1763.3 876.099Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.19 874.098C1763.09 874.298 1763.19 874.798 1763.49 874.498C1763.59 874.398 1763.49 873.898 1763.19 874.098Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.4 874.898C1763.4 875.098 1763.5 875.598 1763.8 875.298C1763.8 875.098 1763.6 874.698 1763.4 874.898Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1763.7 875.7C1763.7 875.9 1763.9 876.4 1764.1 876C1764.1 875.9 1763.9 875.5 1763.7 875.7Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.09 876.6C1764.09 876.8 1764.49 877.2 1764.59 876.8C1764.49 876.6 1764.29 876.3 1764.09 876.6Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.59 877.301C1764.69 877.501 1765.09 877.801 1765.09 877.501C1765.09 877.201 1764.69 877.001 1764.59 877.301Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.3 877.9C1765.4 878 1765.9 878.3 1765.8 877.9C1765.7 877.7 1765.3 877.6 1765.3 877.9Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.99 878.299C1766.09 878.399 1766.59 878.599 1766.49 878.299C1766.39 878.099 1765.99 877.999 1765.99 878.299Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.3 878.701C1767.1 878.701 1766.6 878.601 1766.9 878.301C1767.1 878.301 1767.6 878.501 1767.3 878.701Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.09 878.698C1767.99 878.698 1767.79 878.698 1767.59 878.698C1767.69 878.498 1767.99 878.598 1768.09 878.698Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.5 876.098C1773.4 876.198 1773.4 876.198 1773.3 876.298C1771.8 876.498 1769.3 875.598 1768.4 874.998C1768.5 875.698 1770.1 877.198 1770.5 877.498C1769.8 877.298 1768.3 875.698 1768.2 874.998C1768.2 874.998 1767.9 876.298 1768 876.498C1768.1 876.698 1768.5 877.698 1768.4 877.698C1768.3 877.698 1767.7 876.698 1767.7 876.398C1767.7 876.198 1767.9 874.998 1767.9 874.998C1767.4 875.298 1766.1 876.298 1765.7 876.898C1765.7 876.098 1767.4 875.098 1767.8 874.798C1767.4 874.898 1764 875.298 1763.9 874.398C1764.6 874.698 1767.2 874.698 1767.9 874.498C1767.9 874.298 1768.1 874.398 1768.2 874.498C1768.2 874.498 1768.4 874.398 1768.5 874.498C1769 875.398 1771.9 875.998 1773.5 876.098Z",
    fill: "#FFABA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.7 872.299C1760.6 872.199 1760.8 871.699 1761 871.699C1761 871.799 1760.8 872.199 1760.7 872.299Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.29 872.9C1760.09 872.8 1760.29 872 1760.49 872C1760.49 872.1 1760.39 872.8 1760.29 872.9Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.3 876.997C1766.2 876.797 1766.4 876.297 1766.7 876.297C1766.7 876.397 1766.4 876.897 1766.3 876.997Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767.7 877.398C1767.5 877.398 1767.3 876.798 1767.5 876.598C1767.5 876.698 1767.7 877.298 1767.7 877.398Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1767 876.898C1766.8 876.598 1767 875.498 1767.5 875.398C1767.5 875.698 1767.2 876.798 1767 876.898Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.09 878.698C1765.89 878.698 1765.69 878.698 1765.59 878.698C1765.59 878.498 1765.89 878.698 1766.09 878.698Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.1 875.898C1764.9 875.998 1764.7 875.698 1764.9 875.598C1765.2 875.498 1765.3 875.798 1765.1 875.898Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.6 875.699C1765.4 875.799 1765.3 875.499 1765.5 875.399C1765.6 875.299 1765.8 875.599 1765.6 875.699Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.4 875.398C1765.3 875.598 1765 875.498 1765.1 875.298C1765.2 874.998 1765.4 875.098 1765.4 875.398Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765 875.297C1765.1 875.497 1764.8 875.597 1764.7 875.397C1764.6 875.197 1764.9 875.097 1765 875.297Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.6 875.497C1764.8 875.597 1764.7 875.897 1764.5 875.797C1764.3 875.697 1764.4 875.397 1764.6 875.497Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.5 875.899C1764.7 875.799 1764.8 876.099 1764.6 876.199C1764.5 876.199 1764.3 875.999 1764.5 875.899Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.8 876.199C1764.9 875.999 1765.2 876.099 1765.1 876.299C1764.9 876.499 1764.7 876.399 1764.8 876.199Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.1 876.299C1765 876.099 1765.3 875.999 1765.4 876.199C1765.5 876.399 1765.2 876.499 1765.1 876.299Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1765.5 876.097C1765.3 875.997 1765.4 875.697 1765.6 875.797C1765.8 875.897 1765.7 876.197 1765.5 876.097Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.99 877.398C1766.79 877.498 1766.59 877.198 1766.79 877.098C1766.99 876.898 1767.19 877.298 1766.99 877.398Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.1 877.498C1770.9 877.598 1770.4 877.198 1770.5 876.898C1770.6 876.898 1771.1 877.398 1771.1 877.498Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.79 876.399C1771.69 876.599 1771.09 876.599 1770.99 876.399C1771.09 876.299 1771.69 876.299 1771.79 876.399Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.6 876.697C1770.2 876.797 1769.3 876.297 1769.3 875.797C1769.5 875.797 1770.5 876.397 1770.6 876.697Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772.9 876.598C1772.8 876.998 1771.8 877.398 1771.4 877.098C1771.6 876.898 1772.7 876.498 1772.9 876.598Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1771.2 876.797C1771.2 876.997 1770.9 877.097 1770.8 876.897C1770.8 876.697 1771.2 876.597 1771.2 876.797Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.5 877.197C1769.4 877.297 1768.9 876.997 1768.9 876.797C1769 876.797 1769.5 877.097 1769.5 877.197Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.8 877.298C1768.5 877.198 1768.1 876.398 1768.3 876.098C1768.4 876.098 1768.8 877.098 1768.8 877.298Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.99 877.597C1768.89 877.797 1768.59 877.697 1768.69 877.497C1768.79 877.197 1769.09 877.397 1768.99 877.597Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.39 856.398C1771.69 859.298 1768.79 861.998 1765.59 864.498C1768.29 861.598 1771.19 858.898 1774.39 856.398Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1647.6 826.402H1645V972.002H1647.6V826.402Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.05 780.114L1628.69 842.48L1630.53 844.319L1692.89 781.953L1691.05 780.114Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660.49 972H1632.09V974.6H1660.49V972Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.2 789.801L1702 781.501L1693.7 774.801L1687.1 781.001L1693.2 789.801Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1702 781.5L1693.2 789.8L1690.8 786.3L1698.3 778.5L1702 781.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.3 803.599L1716 781.299L1704.7 775.199L1686.9 791.899L1692.3 803.599Z",
    fill: "#2B454E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1692.3 803.601L1716 781.301L1808.9 829.401L1810 974.501L1692.3 803.601Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1739.9 974.601H1737.4V880.801H1714.4V974.601H1711.9V878.301H1739.9V974.601Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.69 892.402H1675.49V896.602H1738.69V892.402Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1738.59 892.402H1710.39V896.602H1738.59V892.402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.69 947.402H1675.49V966.102H1738.69V947.402Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1738.59 947.402H1710.39V966.102H1738.59V947.402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.59 955.703H1720.39V957.703H1728.59V955.703Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.69 927.199H1675.49V945.899H1738.69V927.199Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1738.59 927.199H1710.39V945.899H1738.59V927.199Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.59 935.598H1720.39V937.598H1728.59V935.598Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.69 907.102H1675.49V925.802H1738.69V907.102Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1738.59 907.102H1710.39V925.802H1738.59V907.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1728.59 915.402H1720.39V917.402H1728.59V915.402Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.79 882.602H1705.09V892.402H1708.79V882.602Z",
    fill: "#375A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.49 883.902H1706.09V889.902H1708.49V883.902Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.89 882H1705.89V882.6H1707.89V882Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.19 880.102H1706.59L1706.39 882.002H1707.39L1707.19 880.102Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.5 882.602H1709.8V892.402H1713.5V882.602Z",
    fill: "#1A2E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1713.3 883.902H1710.9V889.902H1713.3V883.902Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712.7 882H1710.7V882.6H1712.7V882Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712 880.102H1711.3L1711.2 882.002H1712.2L1712 880.102Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.4 874.801H1686.4V892.401H1696.4V874.801Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1694.7 873.102H1688.3V874.902H1694.7V873.102Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692 873.901H1691C1690 864.301 1695.8 868.401 1701.1 870.701L1700.9 871.101C1696 870.001 1691 865.101 1692 873.901Z",
    fill: "#FFC800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.2 974.601H1699.7V880.801H1676.7V974.601H1674.2V878.301H1702.2V974.601Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.5 931.502C215.4 931.602 202.8 931.902 193.8 931.902H193.5V931.502V923.002V922.602H193.9L209.2 922.702L224.5 922.902H224.7V923.102L224.5 931.502ZM224.5 931.502L224.3 923.002L224.5 923.202L209.2 923.402L193.9 923.502L194.3 923.102V931.602L193.9 931.202C202.6 931.202 215.5 931.402 224.5 931.502Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.403 933.699H176.703V942.199H207.403V933.699Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.406 931.502C181.306 931.602 168.706 931.902 159.706 931.902H159.406V931.502V923.002V922.602H159.806L175.106 922.702L190.406 922.902H190.606V923.102L190.406 931.502ZM190.406 931.502L190.206 923.002L190.406 923.202L175.106 923.402L159.806 923.502L160.206 923.102V931.602L159.806 931.202C168.506 931.202 181.406 931.402 190.406 931.502Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.903 807.301H110.203V815.801H140.903V807.301Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.3 851.102H115.5V925.702H170.3V851.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.102 928.601V848.301H112.602V928.601H173.102ZM170.202 925.801H115.402V851.201H170.202V925.801Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.883 867.628V909.328H153.783V867.628H131.883Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.402 848.301H173.102V928.701H175.402V848.301Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.105 810.102H193.305V884.702H248.105V810.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.906 887.601V807.301H190.406V887.601H250.906ZM248.006 884.801H193.206V810.201H248.006V884.801Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.603 826.602H209.703V868.302H231.603V826.602Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.206 807.301H250.906V887.701H253.206V807.301Z",
    fill: "#DCDCDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_33043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage9);
export default __webpack_public_path__ + "static/media/image9.bb7b8c5150b028bece16c88690f60377.svg";
export { ForwardRef as ReactComponent };